import React, { useState } from 'react';
import CyberReveal from '../CyberReveal';
import Section from '../Section';
import { BENEFITS_NOTE } from '../content';
import styles from './Benefits.module.css';

const ASSET_BASE = `${process.env.PUBLIC_URL}/assets/images/raid2026`;
const LOGO_SRC = `${ASSET_BASE}/logo_raid_simple.svg`;
const BENEFIT_CARDS = [
  {
    src: 'benefit_card_01.png',
    alt: '参加特典01 インターン修了者全員にApple Mac miniプレゼント',
  },
  {
    src: 'benefit_card_02.png',
    alt: '参加特典02 有給インターン 時給10,000円支給',
  },
  {
    src: 'benefit_card_03.png',
    alt: '参加特典03 優勝賞金100万円／人 新規事業発足チャンスあり',
  },
  {
    src: 'benefit_card_04.png',
    alt: '参加特典04 対面選考からインターンまで交通費・宿泊費全額支給',
  },
  {
    src: 'benefit_card_05.png',
    alt: '参加特典05 インターンの全過程が動画コンテンツ化・YouTubeやSNSで公開予定',
  },
];

function BenefitCardImage({ card }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={styles.cardShell} aria-busy={!loaded}>
      {!loaded && (
        <span
          className={styles.loader}
          role="status"
          aria-label="参加特典画像を読み込み中"
        />
      )}
      <img
        src={`${ASSET_BASE}/${card.src}`}
        alt={card.alt}
        className={`${styles.cardImage} ${loaded ? styles.cardImageLoaded : ''}`}
        loading="lazy"
        decoding="async"
        width="4376"
        height="1132"
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
      />
    </div>
  );
}

export default function Benefits() {
  return (
    <Section id="benefits">
      <div className={styles.header}>
        <img
          src={LOGO_SRC}
          alt="RAID"
          className={styles.headerLogo}
          loading="lazy"
          decoding="async"
          width="287"
          height="196"
        />
        <h2 className={styles.headerTitle}>参加特典</h2>
      </div>
      <CyberReveal as="ul" className={styles.list} variant="scan">
        {BENEFIT_CARDS.map((card, index) => (
          <li
            key={card.src}
            className={styles.card}
            style={{ '--benefit-card-delay': `${index * 110}ms` }}
          >
            <BenefitCardImage card={card} />
          </li>
        ))}
      </CyberReveal>
      <p className={styles.note}>{BENEFITS_NOTE}</p>
    </Section>
  );
}
